jQuery(function($){
	$('.sc-field-editor .field.tel input[type=tel]').on('change', function(){
		let input = $(this);
		let data = {
			action: 'choralorg_ajax_update_phone_format',
			value: $(this).val()
		};
		$.post('/wp-admin/admin-ajax.php', data, function(response){
			input.val(response.trim());
		});
	});

	if($('select[name="sc-fields[display_name]"]').length) {
		updateDisplayNameValues();

		const changeFields = [
			'first_name',
			'middle_initial',
			'last_name',
			'suffix',
			'nickname',
		];
		$.each(changeFields, function(index, value){
			$('input[name="sc-fields[' + value + ']"]').on('keyup', updateDisplayNameValues);
		});

		function updateDisplayNameValues() {
			const fields = [
				'first_name',
				'middle_initial',
				'last_name',
				'suffix',
				'nickname',
			];

			let fieldValues = {};
			$.each(fields, function(index, value){
				fieldValues[value] = $('input[name="sc-fields[' + value + ']"]').val();
			});

			const options = $('select[name="sc-fields[display_name]"]').find('option');

			let data = {
				action: 'choralorg_display_name_select_options',
				field_values: fieldValues,
			};

			options.each(function(){
				if($(this).val()) {
					const selectOption = $(this);
					data.option = selectOption.val();
					$.post('/wp-admin/admin-ajax.php', data, function(response){
						console.log(response);
						selectOption.html(response);
					})
				}
			});
		}
	}

	$('a.update-profile').on('click', function(e){
		e.preventDefault();
		
		if($(this).hasClass('active')) {
			//Hide update form
			$(this).removeClass('active');
			$('#choralorg-wrapper').removeClass('update-profile-active');
		} else {
			//Show update form
			$(this).addClass('active');
			$('#choralorg-wrapper').addClass('update-profile-active');
		}
	});

	$('body.wp-admin').on('click', '.components-panel .sc-field-editor .field.html a.edit-bio-link', function(e){
		e.preventDefault();

		const parentDiv = $(this).closest('.fields');
		const typeaheadField = parentDiv.find('.field.typeahead[field_name="member_id"]');
		const typeaheadValue = typeaheadField.find('.member_id.typeahead-value').val();

		console.log('clicked', typeaheadValue);

		if(parseInt(typeaheadValue) == typeaheadValue) {
			const url = '/wp-admin/post.php?post=' + typeaheadValue + '&action=edit&field_focus=bio';
			window.open(url, '_blank');
		}
	});
});